import * as React from 'react'
import { Button, CustomInput, ModalFooter, ModalHeader, Row } from 'reactstrap'
import { SaveButton } from '@hyper/button'
import ModalBody from 'reactstrap/lib/ModalBody'
import { FormProvider, useForm } from 'react-hook-form'
import { endOfMonth, startOfMonth, startOfToday } from 'date-fns'
import { SourceInput } from '@modules/reports/user-reports/common/source-input'
import { DateFromToInput } from '@modules/reports/user-reports/common/date-from-to-input'
import { OptionsInput } from '@modules/reports/user-reports/reports-generator-reservation/options-input'
import { RootState, useAppDispatch, useAppSelector } from '@store/index'
import { createReportTask } from '@store/actions/report-tasks-actions'
import { FormPlain } from '@hyper/forms'
import { extractInnerRef } from '@helpers/forms'
import { useReportFormRequest } from '@modules/reports/hooks/use-report-request'
import { BaseModalProps } from '@components/modals/types'

interface FormInputs {
  date_from: Date | null
  date_to: Date | null
  date_from_range: boolean
  created_at_from: Date | null
  created_at_to: Date | null
  close_datetime_from: Date | null
  close_datetime_to: Date | null
  cancelled: boolean
  incomplete: boolean
  is_subscription_reservation: boolean
  is_special_reservation: boolean
  sources: string[]
}

export const ReportsGeneratorReservation: React.FC<BaseModalProps> = ({ toggleIsVisible }) => {
  const reportUrl = useAppSelector((state: RootState) => state.appState.appData.urls.reports.report_task_reservations)
  const dispatch = useAppDispatch()

  const methods = useForm<FormInputs>({
    mode: 'all',
    defaultValues: {
      date_from: startOfMonth(startOfToday()),
      date_to: endOfMonth(startOfToday()),
      created_at_from: null,
      created_at_to: null,
      date_from_range: false,
      close_datetime_from: null,
      close_datetime_to: null,
    },
  })

  const { isLoading, action: onSubmit } = useReportFormRequest(async (payload: FormInputs) => {
    const reportTask = await dispatch(createReportTask([reportUrl, payload]))
    toggleIsVisible()

    return reportTask
  }, methods.setError)

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <ModalHeader toggle={toggleIsVisible}>Raport rezerwacji</ModalHeader>
        <ModalBody>
          <Row>
            <DateFromToInput label="Termin pobytu" startDateName="date_from" endDateName="date_to" />
            <FormPlain name="date_from_range" colClassName="mb-2">
              <CustomInput
                className="mt-2"
                type="checkbox"
                {...extractInnerRef(methods.register('date_from_range'))}
                id="date_from_range"
                label="Uwzględnij również rezerwacje rozpoczęte"
              />
            </FormPlain>
            <DateFromToInput
              label="Data rozliczenia"
              startDateName="close_datetime_from"
              endDateName="close_datetime_to"
            />
            <DateFromToInput label="Data utworzenia" startDateName="created_at_from" endDateName="created_at_to" />
          </Row>
          <Row>
            <SourceInput />
            <OptionsInput />
          </Row>
        </ModalBody>
        <ModalFooter>
          <Button color="light" type="button" onClick={toggleIsVisible}>
            Zamknij
          </Button>
          <SaveButton className="btn btn-green" label="Zleć raport" labelSaving="Zlecanie.." isSaving={isLoading} />
        </ModalFooter>
      </form>
    </FormProvider>
  )
}
